import { useWeb3ModalProvider } from "@web3modal/ethers/react";
import { BrowserProvider, Contract, Interface } from "ethers";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fromDecimalData, getContractAddress } from "../common/helper";
import STAKING_ABI from "../common/STAKING_ABI.json";
import UPC_ABI from "../common/UPC_abi.json";
import { useWallletContext } from "../hook/useWalletContext";

type Props = {
  apy: number;
};

export const DashboardBalanceCard = ({ apy }: Props) => {
  const navigate = useNavigate();

  const { walletProvider } = useWeb3ModalProvider();
  const { currentAddress } = useWallletContext();

  const [balance, setBalance] = useState<number>(0);
  const [shouldDeposit, setShouldDeposit] = useState<number>(0);

  useEffect(() => {
    if (!currentAddress) {
      return;
    }

    getShouldDepositAmount();
    getBalance();
  }, [currentAddress]);

  const getShouldDepositAmount = async () => {
    try {
      const provider = new BrowserProvider(walletProvider!);
      const signer = await provider.getSigner();

      const staking = new Contract(
        getContractAddress(apy)!,
        new Interface(STAKING_ABI).format(false),
        signer
      );

      const shouldDepositAmount = parseFloat(
        fromDecimalData(await staking.getShouldDepositAmount())
      );

      setShouldDeposit(shouldDepositAmount);
    } catch (err) {
      console.log(err);

      setShouldDeposit(0);
    }
  };

  const getBalance = async () => {
    try {
      const provider = new BrowserProvider(walletProvider!);
      const signer = await provider.getSigner();

      const upc = new Contract(
        process.env.REACT_APP_UPC_CONTRACT!,
        new Interface(UPC_ABI).format(false),
        signer
      );

      const balance = parseFloat(
        fromDecimalData(await upc.balanceOf(getContractAddress(apy)))
      );

      setBalance(balance);
    } catch (err) {
      console.log(err);

      setBalance(0);
    }
  };

  return (
    <div className="col-span-12 xl:col-span-6 xxl:col-span-4">
      <div className="box overflow-hidden">
        <div className="box-body">
          <div className="flex">
            <div className="flex space-x-3 rtl:space-x-reverse">
              <div className="avatar rounded-sm bg-primary/10 dark:primary/10 flex">
                <i className="ti ti-report-money text-secondary mx-auto my-auto text-3xl margin-inline-end-auto"></i>
              </div>
              <h6 className="text-lg font-medium text-gray-800 mb-2 dark:text-white my-auto ">
                Contract Balance({apy})
              </h6>
            </div>
          </div>
          <div className="mt-2 grid grid-cols-12">
            <div className="col-span-12 md:col-span-6 xxl:col-span-5">
              <p className="text-s text-gray-400 ">Balance</p>
            </div>
            <div className="col-span-12 md:col-span-6 xxl:col-span-7 text-end ">
              <p className="text-s font-semibold text-gray-800 dark:text-white">
                {balance.toFixed(5)} UPC
              </p>
            </div>
          </div>
          <div className="mt-2 grid grid-cols-12">
            <div className="col-span-12 md:col-span-6 xxl:col-span-5">
              <p className="text-s text-gray-400 ">Should Deposit</p>
            </div>
            <div className="col-span-12 md:col-span-6 xxl:col-span-7 text-end ">
              <p className="text-s font-semibold text-gray-800 dark:text-white">
                {shouldDeposit.toFixed(5)} UPC
              </p>
            </div>
          </div>
          <div className="mt-2 text-center">
            <button
              type="button"
              className="ti-btn ti-btn-primary"
              onClick={() => navigate("/setting")}
            >
              Deposit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
